import { render, staticRenderFns } from "./content-block.vue?vue&type=template&id=4221e6e2&scoped=true&"
import script from "./content-block.vue?vue&type=script&lang=js&"
export * from "./content-block.vue?vue&type=script&lang=js&"
import style0 from "./content-block.vue?vue&type=style&index=0&id=4221e6e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4221e6e2",
  null
  
)

component.options.__file = "content-block.vue"
export default component.exports